const util = {
  formatDate(dateString) {
    try {
      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }

      const year = date.toLocaleDateString('en-US', {
        timeZone: 'Australia/Adelaide',
        year: 'numeric',
      });

      const month = date.toLocaleDateString('en-US', {
        timeZone: 'Australia/Adelaide',
        month: 'long',
      });

      const day = date.toLocaleDateString('en-US', {
        timeZone: 'Australia/Adelaide',
        day: 'numeric',
      });

      return `${day} ${month} ${year}`;
    } catch (error) {
      console.error('Date formatting error:', error);
      return 'Invalid Date Format';
    }
  },
};

export default util;



// WEBPACK FOOTER //
// ./src/untils/util.js